import { cloneDeep, round } from "lodash";
import { ActionData, TvdEroiDto, TVDOpportunityModel } from "./action-center-types";
import { emptyTvdEroiDto } from "./constants";

export class PageStateModel {

    // bool that indicates if the content of the page state needs to be updated
    isUpdateNeeded: boolean = false;

    // array of actions to be displayed in the page state
    actions: ActionData[] = [];

    // tvd opportunity for the actions
    totalTVDOpportunity: number = 0;

    // total TVD opportunities
    opportunityTVD: TVDOpportunityModel | undefined;

    // Check if the actions array is empty]
    isEmpty(): boolean {
        return this.actions.length === 0;
    }

    /**
     * Calculates the total TVD opportunity for the actions.
     * This is done by summing the grouped TVD opportunity of each metric, for each action in the actions array.
     */
    calculateTVDOpportunity() {

        let calculatedTvdEroiDto: TvdEroiDto = cloneDeep(emptyTvdEroiDto);

        if (!this.isEmpty()) {
            this.actions.reduce((acc, currAction) => {
                let currTvd = currAction.groupedTVDOpportunity;

                acc.totalAir += currTvd.totalAir;
                acc.totalRepair += currTvd.totalRepair;
                acc.totalProductivity += currTvd.totalProductivity;
                acc.totalProductivityDollars += currTvd.totalProductivityDollars;
                acc.totalReplacement += currTvd.totalReplacement;
                acc.totalEnergy += currTvd.totalEnergy;
                acc.totalEnergyDollars += currTvd.totalEnergyDollars;
                acc.totalPlasticWaste += currTvd.totalPlasticWaste;
                acc.totalPlasticWasteDollars += currTvd.totalPlasticWasteDollars;
                acc.totalWater += currTvd.totalWater;
                acc.totalWaterDollars += currTvd.totalWaterDollars;
                acc.totalCardboardWaste += currTvd.totalCardboardWaste;
                acc.totalCardboardWasteDollars += currTvd.totalCardboardWasteDollars;
                acc.totalEmployeeSafety += currTvd.totalEmployeeSafety;
                acc.totalPortfolioReduction += currTvd.totalPortfolioReduction;
                acc.totalPortfolioReductionDollars += currTvd.totalPortfolioReductionDollars;
                acc.totalCostAvoidance += currTvd.totalCostAvoidance;
                acc.totalValueDeliveredDollars += 0; // calculated later
                acc.totalSales += 0; // not needed
                return acc;
            }, calculatedTvdEroiDto);
        }

        this.totalTVDOpportunity =
            calculatedTvdEroiDto.totalProductivityDollars +
            calculatedTvdEroiDto.totalRepair +
            calculatedTvdEroiDto.totalReplacement +
            calculatedTvdEroiDto.totalEnergyDollars +
            calculatedTvdEroiDto.totalPlasticWasteDollars +
            calculatedTvdEroiDto.totalWaterDollars +
            calculatedTvdEroiDto.totalCardboardWasteDollars +
            calculatedTvdEroiDto.totalPortfolioReductionDollars +
            calculatedTvdEroiDto.totalCostAvoidance;

        // set the opportunityTVD
        this.opportunityTVD = this.convertTvdOpportunityToTvdOpportunityModel(calculatedTvdEroiDto);
    }

    private convertTvdOpportunityToTvdOpportunityModel(tvdOpportunity: TvdEroiDto | undefined): TVDOpportunityModel | undefined {
        if (tvdOpportunity) {
            // Convert the TVDEroiDto to TVDOpportunityModel
            return {
                "Productivity": round(tvdOpportunity.totalProductivityDollars).toString(),
                "Assets": round((tvdOpportunity.totalRepair + tvdOpportunity.totalReplacement)).toString(),
                "Employee Safety": "0", // No dollar value for employee safety
                "Water": round(tvdOpportunity.totalWaterDollars).toString(),
                "Energy": round(tvdOpportunity.totalEnergyDollars).toString(),
                "Greenhouse Gases": "0", // No dollar value for greenhouse gases
                "Plastic Waste": round(tvdOpportunity.totalPlasticWasteDollars).toString(),
                "Cardboard Waste": round(tvdOpportunity.totalCardboardWasteDollars).toString(),
                "Cost Avoidance": round(tvdOpportunity.totalCostAvoidance).toString()
            };
        }
        return undefined;
    }
}